import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { constantValues } from 'src/app/core/Constants/static';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  private dateFormat:string=constantValues.dateFormat;
  private dateLocale:string=constantValues.dateLocale;
  transform(date: Date | string | undefined | null, args?: any): any {
    if(date){
      return new DatePipe(this.dateLocale).transform(date, this.dateFormat);
    }else return date;
  }

}
